import { motion } from 'framer-motion';
import { CornerDownLeft, MoveRight } from 'lucide-react';
import React from 'react';
import UserBadgeItem from '../Badge/user-badge-item';
import Button from '../Button';
import Card from '../Card';
import Label from '../Label';
import MultiSelect, { Option } from '../MultiSelect';
import Textarea from '../Textarea';
import { Tooltip, TooltipTrigger } from '../Tooltip';


type GuestTeamMemberProps = {
    handleGuestMultiSelectOnChange: (options: Option[]) => void,
    multiSelectguestValue: Option[] | undefined,
    handleChangeGuestNote: React.ChangeEventHandler<HTMLTextAreaElement> | undefined,
    guestNote: string | number | readonly string[] | undefined,
    handleInviteGuest: () => void,
    isInvitingMember: boolean,
}
const MotionCard = motion(Card);
const GuestClient = ({ handleGuestMultiSelectOnChange, multiSelectguestValue, handleChangeGuestNote, guestNote, handleInviteGuest, isInvitingMember }: GuestTeamMemberProps) => {


    return (
        <MotionCard
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.4 }}
            className="mt-4 border-none shadow-none">
            <Card.Content className="flex flex-col gap-2 w-full space-y-4 p-0 ">
                <div className='text-sm'>
                    Invited to <strong>collaborate on this project only.</strong> They <strong>won’t access other parts of the dashboard</strong> and will experience a simplified
                    interface tailored for non-technical users.
                </div>
                <div className='flex flex-col gap-2'>
                    <Label>Add Guests or Clients</Label>
                    <div className="relative flex w-full items-center gap-2">
                        <MultiSelect
                            creatable
                            portal
                            options={multiSelectguestValue}
                            placeholder="Type an email address to add…"
                            onChange={handleGuestMultiSelectOnChange}
                            value={multiSelectguestValue}
                            hideClearAllButton
                            customBadgeComponent={UserBadgeItem}
                            className='rounded-lg'
                            showDropdown={false}
                            emptyIndicator={undefined}
                            rightSection={
                                <Tooltip
                                    content="Pressing enter on your keyboard will add the email address"
                                    delayDuration={100}
                                    side='bottom'
                                    align='end'
                                >
                                    <TooltipTrigger asChild>
                                        <span className="right-1 flex h-[28px] w-8 items-center justify-center rounded-md bg-[#EFF2F6] dark:bg-card text-textcolor">
                                            <CornerDownLeft
                                                size={14} />
                                        </span>
                                    </TooltipTrigger>
                                </Tooltip>
                            }
                        />

                    </div>
                </div>
                <div className='flex flex-col gap-2'>
                    <Label>Add a Note</Label>
                    <Textarea className='placeholder:text-muted-foreground rounded-lg' placeholder="Provide some context for your invite…" value={guestNote} onChange={handleChangeGuestNote} />
                </div>
                <div className="flex justify-end gap-2">
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={handleInviteGuest}
                        loading={isInvitingMember}
                        className='mb-4'
                    >
                        Instant Invite – No Login Needed
                        <MoveRight size={18} />
                    </Button>
                </div>
            </Card.Content>
        </MotionCard>
    );
};

export default GuestClient;